export const reportConstants = {
    REPORT_SAVE_REQUEST: 'REPORT_SAVE_REQUEST',
    REPORT_SAVE_SUCCESS: 'REPORT_SAVE_SUCCESS',
    REPORT_SAVE_FAILURE: 'REPORT_SAVE_FAILURE',
    REPORT_SAVE_CLEAR: 'REPORT_SAVE_CLEAR',
};